import React, { useState } from "react";
import { BASE_URL } from "../../api/api";
import DownloadIcon from "@mui/icons-material/Download";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const OPenCases = () => {
    const [fromdate, setFromdate] = useState("");
    const [todate, setTodate] = useState("");
    const [loading, setLoading] = useState(false);
    const [noData, setNoData] = useState(false);

    const handleAdminDownload = async () => {
        try {
            if (!fromdate || !todate) {
                alert("Please select both From and To dates.");
                return;
            }

            setLoading(true);
            setNoData(false);

            const response = await fetch(`${BASE_URL}/SearchCasesByDate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    fromDate: fromdate,
                    toDate: todate,
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to fetch data");
            }

            const res = await response.json();
            const cases = res?.data || [];
            if (!cases || cases.length === 0) {
                setNoData(true);
                setLoading(false);
                return;
            }

            // const headers = Object.keys(cases[0]).join(",");
            // const rows = cases.map((row) =>
            //     Object.values(row)
            //         .map((val) =>
            //             typeof val === "object" && val !== null ? "" : `"${val}"`
            //         )
            //         .join(",")
            // );
            // const csvContent = [headers, ...rows].join("\n");

            // const blob = new Blob([csvContent], {
            //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;",
            // });
            // const url = URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // link.setAttribute("download", `OpenCases.xlsx`);

            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);

            const worksheet = XLSX.utils.json_to_sheet(cases);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "OpenCases");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });
            const blob = new Blob([excelBuffer], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "OpenCases.xlsx");

            setFromdate("");
            setTodate("");
        } catch (error) {
            console.error("Download failed:", error);
            setNoData(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <h5 style={{ textDecoration: "underline" }}>Select Closure Date</h5>

            <div
                className="pt-3"
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                    alignItems: "end",
                }}
            >
                <div className="d-flex flex-column" style={{ width: "22%" }}>
                    <label htmlFor="fromDate" className="mb-1 text-sm font-medium">
                        From Date
                    </label>
                    <input
                        type="date"
                        className="form-control searchInput"
                        value={fromdate}
                        onChange={(e) => setFromdate(e.target.value)}
                        disabled={loading}
                    />
                </div>

                <div className="d-flex flex-column" style={{ width: "22%" }}>
                    <label htmlFor="toDate" className="mb-1 text-sm font-medium">
                        To Date
                    </label>
                    <input
                        type="date"
                        className="form-control searchInput"
                        value={todate}
                        onChange={(e) => setTodate(e.target.value)}
                        disabled={loading}
                    />
                </div>

                <div className="pt-3" style={{ display: "flex", gap: "10px" }}>
                    <button
                        className="btn btn-primary"
                        onClick={handleAdminDownload}
                        disabled={loading}
                        style={{
                            backgroundColor: "#7E00D1",
                            border: "0px",
                            width: "200px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                        }}
                    >
                        {loading ? (
                            <span
                                className="spinner-border spinner-border-sm text-light"
                                role="status"
                            />
                        ) : (
                            <DownloadIcon />
                        )}
                        {loading ? "Downloading..." : "Download MIS"}
                    </button>
                </div>
            </div>
            {noData && (
                <p className="mt-3 text-danger fw-semibold">No data available</p>
            )}
        </div>
    );
};

export default OPenCases;
